export default class EnumValueNotFoundException extends Error {
  constructor(message) {
    super(message);
    this.name = 'EnumValueNotFoundException';
  }
}
